/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import PageWrapper from './../PageWrapper';

class Faq extends Component {
   render(){
    return (
		<PageWrapper title="faq">
			<div>
				<header class="header">
					<div class="container">
						<div class="top-dec w-left">
							<div class="breadcrumbs">   
								<h1>FAQs</h1>
							</div>
						</div>
					</div>
				</header>
                <div class="faq-main w-left">
                    <div class="container">
                        <p class="border-btm-faq">Sed pellentesque malesuada viverra. Integer sed egestas nisl. Mauris id lorem ut purus blandit gravida. Ut eget tempus mauris. Aliquam a interdum quam. Aliquam nec ullamcorper lorem, ut mattis purus.</p>
                        <ul class="tgl-faq">
                            <li>
                                <h3 className="active">What is Mobiapp?</h3>
                                <div class="faq-toggle-fade abcd">
                                    <p>MobiApp is an easy to use mobile app builder tool for Shopify store owners. It helps businesses deliver the most intuitive experience of shopping for mobile visitors.</p>
                                    <p>MobiApp is an easy to use mobile app builder tool for Shopify store owners. It helps businesses deliver the most intuitive experience of shopping for mobile visitors.</p>
                                </div>
                            </li>
                            <li>
                                <h3 className="active">What is Mobiapp?</h3>
                                <div class="faq-toggle-fade abcd">
                                    <p>MobiApp is an easy to use mobile app builder tool for Shopify store owners. It helps businesses deliver the most intuitive experience of shopping for mobile visitors.</p>
                                </div>
                            </li>
                            <li>
                                <h3 className="active">What is Mobiapp?</h3>
                                <div class="faq-toggle-fade abcd">
                                    <p>MobiApp is an easy to use mobile app builder tool for Shopify store owners. It helps businesses deliver the most intuitive experience of shopping for mobile visitors.</p>
                                </div>
                            </li>
                            <li>
                                <h3 className="active">What is Mobiapp?</h3>
                                <div class="faq-toggle-fade abcd">
                                    <p>MobiApp is an easy to use mobile app builder tool for Shopify store owners. It helps businesses deliver the most intuitive experience of shopping for mobile visitors.</p>
                                </div>
                            </li>
                            <li>
                                <h3 className="active">What is Mobiapp?</h3>
                                <div class="faq-toggle-fade abcd">
                                    <p>MobiApp is an easy to use mobile app builder tool for Shopify store owners. It helps businesses deliver the most intuitive experience of shopping for mobile visitors.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
		</PageWrapper>
	);
   }
	
}
export default Faq;